import { createParser, useQueryState } from "nuqs"

const parseAsOpenString = createParser({
  parse: (value) => value === "open",
  serialize: (value) => (value ? "open" : "")
}).withDefault(false)

export const useDialogQueryState = (key: string) => {
  const [isOpen, setIsOpen] = useQueryState(key, parseAsOpenString.withOptions({ shallow: true }))

  return {
    isOpen,
    setIsOpen
  }
}
